import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=55de7b86&scoped=true&"
import script from "./NestedDraggable.vue?vue&type=script&lang=js&"
export * from "./NestedDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de7b86",
  null
  
)

export default component.exports